import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import type { Testimonial } from '../data/testimonials';
type Props = {
  testimonial: Testimonial;
  delay?: number;
};
export function TestimonialCard({
  testimonial,
  delay = 0
}: Props) {
  return <motion.figure initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.3,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} className="flex flex-col rounded-2xl border border-plum/10 bg-white p-5 shadow-[0_12px_30px_-24px_rgba(10,10,10,0.45)]" data-id="element-256" data-mp="2p7g9rsywsio2">
      <figcaption className="flex items-center gap-3" data-id="element-257" data-mp="345gyo31ddu8p">
        <img src={testimonial.img} alt={testimonial.role} width={48} height={48} loading="lazy" decoding="async" className="h-12 w-12 shrink-0 rounded-full object-cover ring-2 ring-grape-soft ring-offset-2 ring-offset-white" data-id="element-258" data-mp="3872i678et6rv" />
        <div className="min-w-0" data-id="element-259" data-mp="ht2v0ap6r2nm">
          <p className="text-sm font-bold text-plum" data-id="element-260" data-mp="hudxm76wa4d5">⭐ {testimonial.title}</p>
          <p className="text-xs font-medium text-plum/55" data-id="element-261" data-mp="d12zqvk28xxd">{testimonial.role}</p>
        </div>
      </figcaption>
      <div className="mt-4 flex flex-1 gap-2 border-t border-plum/10 pt-4" data-id="element-262" data-mp="83t42y62vq13">
        <QuoteIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" aria-hidden="true" data-id="element-263" data-mp="34pxh9ag9br0" />
        <blockquote className="text-[15px] leading-relaxed text-plum/75" data-id="element-264" data-mp="10s8gdcxtru8q">“{testimonial.quote}”</blockquote>
      </div>
    </motion.figure>;
}